<script setup lang="ts">
/** Диалог закрытия карточки с обязательным комментарием (для статусов с requiresComment). */
import { computed, ref, watch } from 'vue';
import { api } from '@/api';
import { resolvePrompt } from '@/composables/useTicketActions';
import { useBoard } from '@/stores/board';
import { useMeta } from '@/stores/meta';
import { useUi } from '@/stores/ui';
import { UiButton, UiField, UiModal, UiTextarea } from '@/ui';

const meta = useMeta();
const board = useBoard();
const ui = useUi();
const text = ref('');
const saving = ref(false);

const open = computed({
  get: () => !!resolvePrompt.value,
  set: (v) => {
    if (!v) resolvePrompt.value = null;
  },
});
watch(open, (v) => v && (text.value = ''));
const res = computed(() => meta.resolution(resolvePrompt.value?.resolutionKey));

async function save() {
  const p = resolvePrompt.value;
  if (!p || !text.value.trim()) return;
  saving.value = true;
  try {
    const { ticket } = await api.tickets.resolve(p.ticket.id, p.resolutionKey, text.value.trim());
    board.upsert(ticket);
    ui.success(`Закрыто: ${res.value?.title ?? p.resolutionKey}`);
    resolvePrompt.value = null;
  } catch (e) {
    ui.error(e);
  } finally {
    saving.value = false;
  }
}
</script>

<template>
  <UiModal v-model="open" :title="`Закрыть: ${res?.title ?? ''}`" subtitle="Для этого статуса нужен комментарий" :width="460">
    <UiField label="Комментарий" required>
      <UiTextarea v-model="text" :rows="4" placeholder="Что произошло с запросом" />
    </UiField>
    <template #footer>
      <UiButton variant="ghost" @click="open = false">Отмена</UiButton>
      <UiButton variant="primary" :loading="saving" :disabled="!text.trim()" @click="save">Закрыть карточку</UiButton>
    </template>
  </UiModal>
</template>
